import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'

import styles from './OverachieverDialog.module.css'
import { byDesign } from '@/infra/design'
import imgArchiveUrl from '@/assets/misc/img_archive.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export interface OverachieverDialogProps {
  showing: boolean
  onClose: () => unknown
  onFinishOpenJobs: () => unknown
  globalJobCapacity: number
}

export function OverachieverDialog({
  showing,
  onClose,
  onFinishOpenJobs,
  globalJobCapacity,
}: OverachieverDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader withCloseButton></ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgArchiveUrl}
            illustration={byDesign(undefined, DocumentsDisabledIllustration)}
            alt="Illustration of a hand putting a book on a shelf"
          />

          <ModalSheetContentTitle>
            <span className={styles.title}>Hello there, overachiever!</span>
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            <span className={styles.description}>
              Happy to see you’re so eager for more work. Unfortunately, you
              have reached your limit of{' '}
              <span className={styles.bold}>{globalJobCapacity} jobs</span>. To
              unlock more opportunities, complete some of your open jobs first.
            </span>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" variant="default" onPress={onClose} />
          <Button
            label="Finish Open Jobs"
            type="submit"
            variant="primary"
            onPress={onFinishOpenJobs}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
